(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-color-swatches"] && !Shopify.designMode) return;
  try {
    class SwatchLayoutManager {
    constructor() {
      this.containers = new Map();
      this.resizeObserver = null;
      this.init();
    }

    init() {
      // Initialize existing containers
      this.initializeContainers();
      
      // Set up resize observer for responsive behavior
      this.setupResizeObserver();
      
      // Handle dynamic content
      this.observeDynamicContent();
    }

    initializeContainers() {
      const containers = document.querySelectorAll('.swatch-container[data-total-swatches]');
      containers.forEach(container => {
        this.calculateLayout(container);
      });
    }

    setupResizeObserver() {
      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(entries => {
          entries.forEach(entry => {
            const container = entry.target;
            if (container.classList.contains('swatch-container')) {
              this.calculateLayout(container);
            }
          });
        });

        // Observe all swatch containers
        document.querySelectorAll('.swatch-container').forEach(container => {
          this.resizeObserver.observe(container);
        });
      }
    }

    observeDynamicContent() {
      // Use MutationObserver to handle dynamically added content
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Check if the added node is a swatch container
              if (node.classList && node.classList.contains('swatch-container')) {
                this.calculateLayout(node);
                if (this.resizeObserver) {
                  this.resizeObserver.observe(node);
                }
              }
              
              // Check for swatch containers within the added node
              const containers = node.querySelectorAll && node.querySelectorAll('.swatch-container');
              if (containers) {
                containers.forEach(container => {
                  this.calculateLayout(container);
                  if (this.resizeObserver) {
                    this.resizeObserver.observe(container);
                  }
                });
              }
            }
          });
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    calculateLayout(container) {
      if (!container || !container.dataset.totalSwatches) return;

      const totalSwatches = parseInt(container.dataset.totalSwatches);
      if (totalSwatches <= 1) return;

      // Get container width and swatch size
      const containerWidth = container.offsetWidth;
      const swatchSize = this.getSwatchSize();
      const gap = this.getSwatchGap();
      
      // Reserve space for overflow indicator (same size as swatch + gap)
      const overflowIndicatorSpace = swatchSize + gap;
      const availableWidth = containerWidth - overflowIndicatorSpace;
      
      // Calculate how many swatches can fit in one row
      const swatchesPerRow = Math.floor((availableWidth + gap) / (swatchSize + gap));
      
      // Ensure we have at least 1 swatch and space for overflow indicator
      if (swatchesPerRow <= 0 || availableWidth < swatchSize) {
        // If container is too small, show only 1 swatch and overflow indicator
        const swatchItems = container.querySelectorAll('.swatch-item');
        const overflowIndicator = container.querySelector('.overflow-indicator');
        
        swatchItems.forEach((item, index) => {
          if (index === 0) {
            item.classList.remove('hidden');
          } else {
            item.classList.add('hidden');
          }
        });
        
        if (overflowIndicator && totalSwatches > 1) {
          const hiddenCount = totalSwatches - 1;
          const overflowText = overflowIndicator.querySelector('.overflow-text');
          if (overflowText) {
            overflowText.textContent = `+${hiddenCount}`;
          }
          overflowIndicator.setAttribute('aria-label-remaining-count', hiddenCount.toString());
          overflowIndicator.setAttribute('aria-label', `Additional ${hiddenCount} color${hiddenCount === 1 ? '' : 's'}`);
          overflowIndicator.classList.add('visible');
        }
        return;
      }

      // Show swatches that fit in the row, hide the rest
      const swatchItems = container.querySelectorAll('.swatch-item');
      const overflowIndicator = container.querySelector('.overflow-indicator');
      
      let visibleCount = 0;
      let hiddenCount = 0;

      // If we can fit all swatches, show them all
      if (swatchesPerRow >= totalSwatches) {
        swatchItems.forEach((item) => {
          item.classList.remove('hidden');
          visibleCount++;
        });
        hiddenCount = 0;
      } else {
        // Show only the swatches that fit
        swatchItems.forEach((item, index) => {
          if (index < swatchesPerRow) {
            item.classList.remove('hidden');
            visibleCount++;
          } else {
            item.classList.add('hidden');
            hiddenCount++;
          }
        });
      }

      // Update overflow indicator
      if (overflowIndicator) {
        if (hiddenCount > 0) {
          const overflowText = overflowIndicator.querySelector('.overflow-text');
          if (overflowText) {
            overflowText.textContent = `+${hiddenCount}`;
          }
          
          // Update aria-label with just the number (without +)
          overflowIndicator.setAttribute('aria-label-remaining-count', hiddenCount.toString());
          
          // Update title with descriptive text
          const titleText = `Additional ${hiddenCount} color${hiddenCount === 1 ? '' : 's'}`;
          overflowIndicator.setAttribute('aria-label', titleText);
          
          overflowIndicator.classList.add('visible');
        } else {
          // Hide overflow indicator when all swatches are visible
          const overflowText = overflowIndicator.querySelector('.overflow-text');
          if (overflowText) {
            overflowText.textContent = '+0';
          }
          overflowIndicator.setAttribute('aria-label-remaining-count', '0');
          overflowIndicator.classList.remove('visible');
        }
      }
    }

    getSwatchSize() {
      // Get swatch size from CSS custom property
      const root = document.documentElement;
      const computedStyle = getComputedStyle(root);
      
      if (window.innerWidth >= 768) {
        return parseFloat(computedStyle.getPropertyValue('--swatch-size-desktop')) * 16; // Convert rem to px
      } else {
        return parseFloat(computedStyle.getPropertyValue('--swatch-size-mobile')) * 16; // Convert rem to px
      }
    }

    getSwatchGap() {
      // Get gap size from CSS custom property
      const root = document.documentElement;
      const computedStyle = getComputedStyle(root);
      return parseFloat(computedStyle.getPropertyValue('--swatch-gap')) * 16; // Convert rem to px
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new SwatchLayoutManager();
    });
  } else {
    new SwatchLayoutManager();
  }
  } catch(e) { console.error(e); }
})();

})();
